import React from 'react';
import classNames from 'classnames';
import ReturnToTop from './ReturnToTop';
import FooterPrimary from './FooterPrimary';
import FooterNav from './FooterNav';
import SectionContainer from './SectionContainer';
import PrimaryLink from './PrimaryLink';
import SecondaryLinkContainer from './SecondaryLinkContainer';
import SecondaryLink from './SecondaryLink';
import FooterSecondary from './FooterSecondary';
import SignUpForm from './SignUpForm';
import FooterLogo from './FooterLogo';
import ContactLinks from './ContactLinks';
import SocialLinks from './SocialLinks';
import FooterAddress from './FooterAddress';
import FooterContactInfo from './FooterContactInfo';

export interface FooterProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  size?: 'big' | 'slim';
}

const Footer = ({ children, className, id, size }: FooterProps): JSX.Element => {
  const footerClasses = classNames(className, 'usa-footer', size ? `usa-footer--${size}` : null);

  return (
    <footer id={id} className={footerClasses} data-testid="uswds-react-footer">
      {children}
    </footer>
  );
};

Footer.ReturnToTop = ReturnToTop;
Footer.Primary = FooterPrimary;
Footer.Nav = FooterNav;
Footer.SectionContainer = SectionContainer;
Footer.PrimaryLink = PrimaryLink;
Footer.SecondaryLinkContainer = SecondaryLinkContainer;
Footer.SecondaryLink = SecondaryLink;
Footer.Secondary = FooterSecondary;
Footer.Logo = FooterLogo;
Footer.ContactLinks = ContactLinks;
Footer.SocialLinks = SocialLinks;
Footer.Address = FooterAddress;
Footer.ContactInfo = FooterContactInfo;
Footer.SignUp = SignUpForm;

export default Footer;
